import PropTypes, { oneOfType } from "prop-types";
import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API";

import FnrButton from "UI/FnrButton3";
import FnrIcon from "UI/FnrIcon";
import { FnrPopover } from "UI/FnrPopover2";

import {
  MoreButton,
  MoreButtonText,
} from "../../../../Options/Options/MoreButton";

DeleteItemButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  signupListID: PropTypes.number.isRequired,
  itemID: oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  numRespondents: PropTypes.number,
  hasAnyPaidRespondents: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default function DeleteItemButton({
  dispatch,
  signupListID,
  itemID,
  numRespondents,
  hasAnyPaidRespondents = false,
  isDisabled = false,
}) {
  const buttonRef = useRef();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const closeConfirmation = () => {
    setShowConfirmation(false);
  };

  const removeFromList = () => {
    setIsDeleting(true);

    API.removeSignupListItem(signupListID, itemID)
      .post()
      .then(() => {
        dispatch({
          type: "Remove an Item From List",
          ID: itemID,
        });

        // we then AutoNavigate to another item
      })
      .catch((e) => {
        setIsDeleting(false);
        console.error(e.message);
      });
  };

  const getRespondentsWarning = () => {
    if (numRespondents && numRespondents > 0) {
      return <p>This will clear all of the respondents!</p>;
    } else {
      return null;
    }
  };

  const getPaidRespondentsWarning = () => {
    if (hasAnyPaidRespondents) {
      return (
        <p>
          <strong>
            <span className="fas fa-exclamation-triangle" /> This includes
            respondents who have already paid for this Signup.
          </strong>
        </p>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <MoreButton
        onClick={() => setShowConfirmation(true)}
        disabled={isDisabled || isDeleting}
        forceHover={showConfirmation}
        color={"#b4252d"}
        ref={buttonRef}
      >
        <FnrIcon far fa-trash-alt />
        <MoreButtonText>Delete Item</MoreButtonText>
      </MoreButton>

      <FnrPopover
        show={showConfirmation}
        onShouldClose={closeConfirmation}
        buttonRef={buttonRef}
        style={{ width: 250, padding: 10 }}
        color="red"
      >
        Are you sure you want to delete this item?
        {getRespondentsWarning()}
        {getPaidRespondentsWarning()}
        <ConfirmButtonsWrapper>
          <FnrButton size="small" onClick={closeConfirmation}>
            Cancel
          </FnrButton>

          <FnrButton
            color="red"
            size="small"
            onClick={removeFromList}
            loading={isDeleting}
          >
            Delete
          </FnrButton>
        </ConfirmButtonsWrapper>
      </FnrPopover>
    </>
  );
}

const ConfirmButtonsWrapper = styled.div`
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
`;
